<template>
  <div v-if="isAuthenticated" />
</template>

<script>
import { defineComponent } from "vue";
import debounce from "lodash.debounce";
import useAuthentication from "@/composition/useAuthentication";

export default defineComponent({
  setup() {
    const { isAuthenticated } = useAuthentication();
    return { isAuthenticated };
  },
  computed: {
    deepLink() {
      if (this.$route.query.path) {
        const path = Array.isArray(this.$route.query.path)
          ? this.$route.query.path.find(p => p !== "/home")
          : this.$route.query.path;
        return path.replace(/\/app/g, "");
      }
      return "";
    }
  },
  methods: {
    redirectOnAuthenticated: debounce(async function onAuth() {
      await this.$nextTick();
      if (this.isAuthenticated) {
        const path = this.deepLink || "/newsitems";
        const query = { ...this.$route.query };
        delete query.ticket;
        delete query.path;

        await this.$nextTick();
        this.$router.replace({
          path,
          query
        });
      }
    })
  },
  watch: {
    isAuthenticated: {
      async handler() {
        await this.$nextTick();
        if (this.isAuthenticated) {
          this.redirectOnAuthenticated();
        }
      },
      immediate: true
    }
  }
});
</script>
